import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as cryptoJS from 'crypto-js';
import { ApiConstants } from 'src/app/constants/api-constants';
import { ChangePasswordModalComponent } from 'src/app/shared/components/change-password-modal/change-password-modal.component';
import { masterConfigurationList } from 'src/app/constants/masterConfigList';
import { Subscription } from 'rxjs';
import { LoaderHandlerService, ServicecallService, SharedService } from 'src/app/services';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  @Input() tenantList: any;
  loginForm: FormGroup;
  loginSubmitted: boolean = false;
  errorMessage: any = null;
  confirmHide = true;

  private _loading: boolean = false;
  private _secretKey = ApiConstants.secretKey;
  private _loginSubscription: Subscription;
  private _configurationsInfoSubscription: Subscription;
  private _getTranslateSubscription: Subscription;

  constructor(
    private _router: Router,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _modalService: NgbModal,
    private _sharedData: SharedService,
    private _loaderHandler: LoaderHandlerService
  ) {
    this.loginForm = this._fb.group({
      domain: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      username: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      password: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    // TODO document why this method 'ngOnInit' is empty
    // this.getTenant();
    if (localStorage.getItem('token') != null) {
      this._router.navigateByUrl(this._service.getPrivilegeUrl());
    }
  }
  ngOnDestroy(): void {
    this._loginSubscription?.unsubscribe();
    this._configurationsInfoSubscription?.unsubscribe();
    this._getTranslateSubscription?.unsubscribe();
  }
  login() {
    this.loginSubmitted = true;
    this.errorMessage = null;
    const tenant = this.tenantList.find((x: any) => (x.domain).toLowerCase() === this.loginFormValues['domain'].value.toLowerCase());
    if (this.loginForm.invalid) {
      return;
    } else if (!tenant) {
      this.errorMessage = 'Invalid Organisation';
      return;
    }
    this._loading = true;
    let domain = this.loginFormValues['domain'].value;
    domain = domain.toUpperCase();
    domain = domain.trim();
    localStorage.setItem("domain", domain)
    this._loginSubscription = this._service.Login(domain, this.loginFormValues['username'].value, this._encrypt(this.loginFormValues['password'].value)).subscribe((res: any) => {
      if (res['status']) {
        this._loading = false;
        localStorage.setItem("tenantId", res['response']['tenantId']);
        if (res['response']['default']) {
          this._changePassword(res['response']['default'], res['response']['message']);
        }
        else {
          localStorage.setItem("domain", res['response']['domain'] ? res['response']['domain'] : domain);
          localStorage.setItem("token", res['response']['token']);
          localStorage.setItem("credId", res['response']['credId']);
          localStorage.setItem("userId", res['response']['userId']);
          localStorage.setItem("username", res['response']['userName']);
          res['response']['idmUserName'] ? localStorage.setItem("idmUserName", res['response']['idmUserName']) : '';
          localStorage.setItem("index", res['response']['index']);
          localStorage.setItem("userFullName", res['response']['name'] ? (res['response']['name']?.first ? res['response']['name']?.first : '') : '');
          localStorage.setItem("userImg", JSON.stringify(res['response']['image']));
          localStorage.setItem("cid", res['response']['clientId']);
          localStorage.setItem("entityIds", res['response']?.['entityIds']?.length ? JSON.stringify(res['response']['entityIds']) : null);
          localStorage.setItem("roleId", res['response']['roleId']);
          localStorage.setItem("layouts", res?.['response']?.['layouts'] ? JSON.stringify(res?.['response']?.['layouts']) : null);
          localStorage.setItem("userGroupName", res['response']['userGroupName']);
          // res['response']['response']['domain'].toLowerCase()
          this._configurationsInfoSubscription = this._service.configurationsInfo(masterConfigurationList).subscribe((data: any) => {
            let mappedConfigList = [];
            if (data.status) {
              if (data.response.length) {
                mappedConfigList = data.response.map((item: any) => {
                  const obj = {};
                  obj['attribute'] = item.attribute;
                  obj['values'] = item.values;
                  obj['_id'] = item._id;
                  return obj;
                });
              }
              this._service.setConfiguration(mappedConfigList);
              if (this._service.getConfiguration('translation') && Object.keys(this._service.getConfiguration('translation'))?.length) {
                localStorage.setItem("trans", JSON.stringify(this._service.getConfiguration('translation')['menu']));
              } else {
                this._getTranslateSubscription = this._service.getTranslate('sim').subscribe((item: any) => {
                  this._loaderHandler.toggleLoader(0);
                  localStorage.setItem("trans", JSON.stringify(item['menu']));
                });
              }
              // if (this._service.getPrivilegeUrl()) {
              //   this._router.navigateByUrl(this._service.getPrivilegeUrl());
              // } else {
              //   this._service.toasterService({ type: 'warning', msg: 'Sorry, you dont have relevant privilege to access the portal. Please contact admin and try again.' });
              //   localStorage.clear();
              //   sessionStorage.clear();
              //   this.loginForm.reset();
              // }
              this._service.setRbacList();
            } else {
              this._service.toasterService({ type: 'error', msg: data?.response?.message });
              this._service.setConfiguration(mappedConfigList);
            }
            if (!mappedConfigList.length) {
              this._service.toasterService({ type: 'warning', msg: 'Configuration is not available, please provide the required configuration for the app' });
            }
          });
          //   this._service.configurationsInfo(['translation']).subscribe((data:any)=>
          //   {
          //     if(data.status) {
          //       localStorage.setItem("trans", JSON.stringify(data.response[0]?.values['menu']));
          //     } else {
          //       this._service.getTranslate('sim').subscribe((item:any)=>
          //         {
          //           this.loaderHandler.toggleLoader(0);
          //           localStorage.setItem("trans", JSON.stringify(item['menu']));
          //       });
          //     }
          //     if(this._service.getPrivilegeUrl()){
          //     this.router.navigateByUrl(this._service.getPrivilegeUrl());
          //     } else {
          //       this._service.toasterService({ type: 'warning', msg: 'Sorry, you dont have relevant privilege to access the portal. Please contact admin and try again.' });
          //       localStorage.clear();
          //       sessionStorage.clear();
          //       this.loginForm.reset();
          //     }
          // });
          setTimeout(() => {
          const tenantGenericConfig =  this._service.getConfiguration('tenantGenericConfig') ? this._service.getConfiguration('tenantGenericConfig') : null;
          localStorage.setItem("tenantGenericTheme", tenantGenericConfig?.theme);
          });
        }
      } else {
        this._loading = false;
        this.errorMessage = res['response']['message'];
      }
    });
  }

  register() {
    this._router.navigateByUrl('signup');
  }

  loadForgotPasswordForm() {
    this._router.navigate(['forgotPassword'])
  }
  // getTenant() {
  //   this.loading = true;
  //   this._service.getTenantDetails().subscribe((res: any) => {
  //     if (res['status']) {
  //       if (res['response'] && res['response']['response'].length > 0) {
  //         this.tenantList = res['response']['response'];
  //       }
  //       this.loading = false;
  //     } else {
  //       this.loading = false;
  //     }
  //   });
  // }

  get loginFormValues() {
    return this.loginForm.controls;
  }

  private _encrypt(value: string): string {
    let k = cryptoJS.enc.Utf8.parse(this._secretKey.trim());
    let cypher = cryptoJS.AES.encrypt(value, k, { mode: cryptoJS.mode.ECB })
    return cryptoJS.enc.Hex.stringify(cypher.ciphertext);
  }

  // decrypt(textToDecrypt: string) {
  //   return cryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(cryptoJS.enc.Utf8);
  // }



  // loadLaunch() {
  //   this.router.navigateByUrl('launch');
  // }

  private _changePassword(info: any, status: any) {
    this._sharedData.send(true);
    const modalRef = this._modalService.open(ChangePasswordModalComponent,
      {
        backdrop: "static",
        keyboard: false,
        windowClass: "PasswordModalClass"
      });
    modalRef.componentInstance.username = this.loginFormValues['username'].value;
    modalRef.componentInstance.oldPassword = this.loginFormValues['password'].value;
    modalRef.componentInstance.message = info;
    modalRef.componentInstance.statusMessage = status;
    modalRef.result.then((result) => {
      this.loginSubmitted = false;
      this.loginForm.reset();
      this._sharedData.send(false);
    }, (reason) => {

    });
  }

  private _navigateToLaunch() {
    this._router.navigate(['/login']);
  }

}
